import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/Home'
import Search from '@/view/Search'
import home1 from '@/view/home/home1'
import homepage from '@/view/home/homepage'
import Personalcenter from '@/view/personalCenter/personalcenter'
import Claimscholar from '@/view/personalCenter/claimscholar'
import Information from '@/view/personalCenter/information'
import Mycomments from '@/view/personalCenter/mycomments'
import Settings from '@/view/personalCenter/settings'
import Stationnews from '@/view/personalCenter/stationnews'
import Introduce from '@/view/introduce/intro'

Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect:'home',
      children:[
        {
          path:"home",
          name:"home",
          component: home1,
          meta: {
            keepAlive: true, 
          }
        },
        {
          path: 'search',
          name: 'Search',
          component: Search,
          meta: {
            keepAlive: true, 
          }
        },
        {
          path: 'homepage',
          name: 'homepage',
          component: homepage,
          meta: {
            keepAlive: false, 
          }
        },
        {
          path: 'personalcenter',
          name: 'personalcenter',
          component: Personalcenter,
          children:[
            {
              path:"claimscholar",
              name:"claimscholar",
              component: Claimscholar
            },
            {
              path:"information",
              name:"information",
              component: Information
            },
            {
              path:"mycomments",
              name:"mycomments",
              component: Mycomments
            },
            {
              path:"settings",
              name:"settings",
              component: Settings
            },
            {
              path:"stationnews",
              name:"stationnews",
              component: Stationnews
            },
          ]
        },
        {
          path: 'introduce',
          name: 'introduce',
          component: Introduce
        },
      ]
    }
    
  ],
  scrollBehavior (to, from, savedPosition) {
    if(to.name == from.name && to.name == "home"){
      return;
    }else{
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 0)
      })
    }
    
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js